module.exports = __webpack_public_path__ + "img/locate.af01e886.png";